module.exports = __webpack_public_path__ + "img/venice_home_cut_compressed.4fecd593.jpg";